import { render } from "./index.vue?vue&type=template&id=0fa78d5d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0fa78d5d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/components/header/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fa78d5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fa78d5d', __exports__)) {
    api.reload('0fa78d5d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0fa78d5d", () => {
    api.rerender('0fa78d5d', render)
  })

}


export default __exports__